import React from 'react';
import PropTypes from 'prop-types';
/* styles */
import './menu-item.scss';

class MenuItem extends React.PureComponent {
  handleItemClick = (event) => {
    if (event) {
      event.stopPropagation();
    }
    if (!this.props.isDisabled && this.props.onClick) {
      this.props.onClick(event);
    }
    if (!this.props.preventMenuClose && !this.props.isDisabled) {
      this.context.toggleMenu();
    }
  };

  render() {
    let menuItemClass = 'glu-menu-item glu-flex glu-flex-align-center';
    if (this.props.className) {
      menuItemClass += ` ${this.props.className}`;
    }
    if (!this.props.isDisabled && this.props.onClick) {
      menuItemClass += ' glu-menu-item--clickable';
    }
    if (this.props.isDisabled) {
      menuItemClass += ' glu-menu-item--disabled';
    }
    return (
      <div className={menuItemClass} onClick={this.handleItemClick}>
        <div className="glu-menu-item__icon">
          {this.props.icon && <span className={`g-icon g-icon-${this.props.icon}`} />}
        </div>
        <span className="glu-menu-item__text">{this.props.children}</span>
      </div>
    );
  }
}

MenuItem.contextTypes = {
  toggleMenu: PropTypes.func.isRequired,
};

MenuItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  preventMenuClose: PropTypes.bool,
};

MenuItem.defaultProps = {
  children: null,
  className: '',
  icon: '',
  isDisabled: false,
  onClick: undefined,
  preventMenuClose: false,
};

export default MenuItem;
